module.exports = {
	"liveOpenID": "lance.cheng"
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/live.json
// module id = 205
// module chunks = 0